import React, { useState } from "react";
import Notification from "./firebase/Notification";
import axios from "axios";
import { config } from "./config";
import { useNavigate } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";

export default function Verify() {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const mobile = localStorage.getItem("phoneNumber"); // Example; replace with actual
  const latitude = 12.3456;
  const longitude = 78.9012;

  const handleOtpChange = (element, index) => {
    const newOtp = [...otp];
    newOtp[index] = element.value;
    setOtp(newOtp);

    // Auto-focus to next input
    if (element.nextSibling && element.value) {
      element.nextSibling.focus();
    }
  };

  const navigate = useNavigate();
  const [promotions, setPromotions] = useState([]);
  const [error, setError] = useState(null);

  // const handleVerify = async () => {
  //   const otpCode = otp.join("");

  //   if (otpCode.length !== 6) {
  //     alert("Please enter a valid 6-digit OTP");
  //     return;
  //   }

  //   try {
  //     const response = await axios.post(
  //       `${config.api_base}api/auth/verify_user`,
  //       {
  //         mobile_number: mobile,
  //         otp: parseInt(otpCode),
  //         latitude,
  //         longitude,
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     if (response.status === 200) {
  //       console.log("✅ Verification Success:", response.data);

  //       const userType = response.data.token.type;

  //       // Store token/user info in localStorage or context if needed
  //       localStorage.setItem("token", response.data.token.accessToken);

  //       console.log(userType);
  //       console.log(response.data.locationId);
  //       console.log(response.data.token.accessToken);

  //       // Navigate based on user type
  //       if (userType === "USER") {
  //         alert(
  //           "You are logged in as a user, but you are not authorized to access the user dashboard."
  //         );
  //         navigate("/"); // or wherever the user should go
  //       } else if (userType === "SHOP") {
  //         alert("Shopkeeper verified successfully!");

  //         localStorage.setItem("locationId", response.data.locationId);
  //         localStorage.setItem("accessToken", response.data.token.accessToken);

  //         await shopId();

  //         // Wait for 2-3 seconds
  //         await new Promise((resolve) => setTimeout(resolve, 3000));

  //         navigate("/shophome");
  //       } else {
  //         alert(
  //           "Oops! You need to create an account in the Adoop app before you can log in."
  //         );
  //         navigate("/");
  //       }
  //     } else {
  //       console.log("❌ Verification Failed:", response.data);
  //       alert("Verification failed!");
  //     }
  //   } catch (err) {
  //     console.error("Error:", err);
  //     alert("Something went wrong.");
  //   }
  // };



const [modalInfo, setModalInfo] = useState({ show: false, message: "", callback: null });


  const handleVerify = async () => {
  const otpCode = otp.join("");

  if (otpCode.length !== 6) {
    setModalInfo({ show: true, message: "Please enter a valid 6-digit OTP" });
    return;
  }

  try {
    const response = await axios.post(
      `${config.api_base}api/auth/verify_user`,
      {
        mobile_number: mobile,
        otp: parseInt(otpCode),
        latitude,
        longitude,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.status === 200) {
      console.log("✅ Verification Success:", response.data);

      const userType = response.data.token.type;

      localStorage.setItem("token", response.data.token.accessToken);

      if (userType === "USER") {
        setModalInfo({
          show: true,
          message:
            "You are logged in as a user, but you are not authorized to access the user dashboard.",
          callback: () => navigate("/"),
        });
      } else if (userType === "SHOP") {
        setModalInfo({
          show: true,
          message: "Shopkeeper verified successfully!",
          callback: async () => {
            localStorage.setItem("locationId", response.data.locationId);
            localStorage.setItem("accessToken", response.data.token.accessToken);
            await shopId();
            navigate("/shophome");
          },
        });
      } else {
        setModalInfo({
          show: true,
          message:
            "Oops! You need to create an account in the Adoop app before you can log in.",
          callback: () => navigate("/"),
        });
      }
    } else {
      console.log("❌ Verification Failed:", response.data);
      setModalInfo({ show: true, message: "Verification failed!" });
    }
  } catch (err) {
    console.error("Error:", err);
    setModalInfo({ show: true, message: "Something went wrong." });
  }
};

  const shopId = async () => {
    const access_token = localStorage.getItem("accessToken");
    

    const url = `${config.api_base}api/v2/shop_details`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch promotions");
      }

      const data = await response.json();
      console.log(url);

      console.log("Promotions:", data);
      console.log("Promotions Shop Id:", data.id);
      localStorage.setItem("userId", data.id);
      setPromotions(data);
    } catch (err) {
      console.error("Error fetching promotions:", err);
      setError(err.message);
    }
  };

  // useEffect(() => {
  //   shopId();
  // }, []);

  return (
    <>
      <Notification />
      <section
        className="h-100 gradient-form"
        style={{ backgroundColor: "#eee" }}
      >
        <div className="container py-5 h-100">
          <div className="row d-flex justify-content-center align-items-center h-100">
            <div className="col-xl-10">
              <div className="card rounded-3 text-black">
                <div className="row g-0">
                  <div className="col-lg-6">
                    <div className="card-body p-md-5 mx-md-4">
                      <div className="text-center">
                        <a
                          href="https://adoop.in/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            src="assets/img/logo/adoop-png.png"
                            style={{ width: "185px" }}
                            alt="logo"
                          />
                        </a>
                        <h5 className="mt-1 mb-5 pb-1">
                          Smart Promotions Start with Adoop
                        </h5>
                      </div>
                      <div className="card p-4 text-center">
                        <h5>Verify Your Account</h5>
                        <div>
                          <span>
                            Enter the verification code sent to your phone
                          </span>
                          <small id="maskedNumber">*******9897</small>
                        </div>
                        <div
                          id="otp"
                          className="inputs d-flex flex-row justify-content-center mt-4"
                        >
                          {/* {otp.map((digit, index) => (
                            <input
                              key={index}
                              className="m-2 text-center form-control rounded"
                              type="text"
                              maxLength="1"
                              value={digit}
                              onChange={(e) => handleOtpChange(e.target, index)}
                            />
                          ))} */}
                          {otp.map((digit, index) => (
                            <input
                              key={index}
                              className="m-2 text-center form-control rounded"
                              type="text"
                              inputMode="numeric" // Show numeric keyboard on mobile
                              pattern="[0-9]*" // Suggest only digits
                              maxLength="1"
                              value={digit}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d?$/.test(value)) {
                                  // Allow only 0-9 or empty string
                                  handleOtpChange(e.target, index);
                                }
                              }}
                            />
                          ))}
                        </div>
                        <div className="mt-4">
                          <button
                            id="validateBtn"
                            className="btn btn-block fa-lg login-btn btn-2 mb-3 px-4 validate"
                            type="button"
                            onClick={handleVerify}
                          >
                            Validate
                          </button>
                        </div>
                        {/* <div className="d-flex align-items-center justify-content-center mt-4 pb-4">
                          <h6 className="mb-0 me-2">Haven't received the code?</h6>
                          <a href="/">Send again</a>
                        </div> */}
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 d-flex align-items-center gradient-custom-1">
                    <div className="text-white px-3 py-4 p-md-5 mx-md-4">
                      <img
                        src="assets/img/verify1.png"
                        className="img-fluid"
                        alt="verify visual"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Modal
  show={modalInfo.show}
  onHide={() => setModalInfo({ ...modalInfo, show: false })}
  size="sm"
                  // centered
                  dialogClassName="custom-logout-modal"
>
  <Modal.Header closeButton  className="modal-header-warning">
    <Modal.Title className="text-white">Notification</Modal.Title>
  </Modal.Header>
  <Modal.Body className="d-flex align-items-center gap-2">
    {modalInfo.message}
  </Modal.Body>
  <Modal.Footer className="justify-content-end">
    <Button
      variant="outline-secondary"
      className="btn-no"
      onClick={async () => {
        setModalInfo({ ...modalInfo, show: false });
        if (modalInfo.callback) await modalInfo.callback();
      }}
    >
      OK
    </Button>
  </Modal.Footer>
</Modal>

    </>
  );
}
